<template>
  <v-container fluid class="pa-0">
    <div class="main-hero pa-0 d-flex justify-center" style="height: 100vh">
    <v-snackbar
      v-model="showMessage"
      vertical
      bottom
      center
      :color="messageColor"
    >
      <p class="mb-0">{{ message }}</p>
    </v-snackbar>
    
        <div style="margin-top: 100px;width: 100%;" v-if="!success " >
            <h2 style="color: #FFF;" class="text-center">Reestablecer Contraseña</h2>
            <h3 style="color: #FFF;" class="text-center">Ingresa tu Nueva contraseña</h3>
            <v-row align="center" justify="center">
                <v-col cols="12">
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                  class="d-flex flex-column flex-grow-1"
                  style="max-width: 400px; width: 100%; margin: 0 auto;"
                >
                <v-text-field
                v-model="password"
                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="required"
                :type="showPass ? 'text' : 'password'"
                name="input-10-1"
                label="Contraseña"
                hint="Mínimo 8 caracteres"
                dark
                @click:append="showPass = !showPass"
                class="custom-placeholer-color text-field-custom mt-5"
              ></v-text-field>
              <v-text-field
                v-model="password_confirmation"
                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="required"
                :type="showPass ? 'text' : 'password'"
                name="input-10-1"
                label="Confirma Contraseña"
                hint="Mínimo 8 caracteres"
                dark
                @click:append="showPass = !showPass"
                class="custom-placeholer-color text-field-custom mt-5"
              ></v-text-field>
                <p v-if="password !== password_confirmation" style="color: #FFFF;" > *Contraseñas no coinciden</p>
                <v-btn
                variant="outlined"
                color="primary"
                style="background: white; font-weight: 600;"
                class="mr-4 mt-4"
                @click="resetPass"
                :loading="loader"
                :disabled="loader && password && password_confirmation && password !== password_confirmation"
              >
                Recuperar Contraseña
              </v-btn>
                </v-form>
                </v-col>
            </v-row> 
    </div>
    <div v-else style="display: flex; justify-content:center; gap: 12px;flex-direction: column;">
      <div style="display: flex;  align-items: center; gap: 12px;">
        <h2 class="text-center text-white">Se ha restablecido tu contraseña</h2>
        <v-icon style="display:flex; font-size: 32px;" class="text-center white--text" large color="green">mdi-check-circle</v-icon>
      </div>
			<v-btn color="primary" variant="outlined" style="background: #FFF;"  to="/">Ingresar</v-btn>
    </div>
    </div>
  </v-container>
</template>

<script>
import {  resetPass  } from '../../helpers/api/user'
    export default {
    data () {
        return {
            success: false,
            showMessage: false,
            messageColor: "error",
            message: "",
            email: null,
            loader: false,
            token: null,
            isValidToken: false,
            password: "",
            password_confirmation: "",
            showPass: false,
            valid: false,
	        form: null,
            required: [
                v => !!v || 'Este campo es obligatorio'
            ]
        }
    },

    methods: {
      async  resetPass() {

    const data = {token: this.token, email: this.email, password: this.password, password_confirmation: this.password_confirmation}
    this.loader = true
    resetPass(data).then(res => {
        this.loader= false
        this.success = true
		}).catch(e => {
        console.log(e.response.data.message);
        this.loader= false
        this.message = e.response.data.message
        this.messageColor = "warning";
        this.showMessage = true;
        })
    }
    },
    mounted () {
        if (!this.$route.query.token || !this.$route.query.email) {
            this.$router.push({ path: '/' });
        } else {
            this.token = this.$route.query.token;
            this.email = this.$route.query.email;
        }
    },
    }
</script>

<style scoped>
    .loader {
      height: 15px;
      aspect-ratio: 5;
      -webkit-mask: linear-gradient(90deg#007BED ,#FFF 20% 80%,#007BED);
      background: radial-gradient(closest-side at 37.5% 50%,#FFF 94%,#007BED) 0/calc(80%/3) 100%;
      animation: l48 .75s infinite linear;
    }
    @keyframes l48 {
      100% {background-position: 36.36%}
    }
    .main-hero {
  background: linear-gradient(140deg,#3587c2 0%, #003153 100%) !important;
  
}
  .text-field-custom  {
    color: #f2f3f5;
  }
.custom-placeholer-color input::placeholder {
  color: #f2f3f5 !important;
  opacity: 1;
}

.custom-label-color .v-label {
  color: #f2f3f5 !important;
  opacity: 1;
}
.custom-label-color.v-input--error {
  color: #f2f3f5!important; /* Cor vermelha */
  caret-color: #f2f3f5!important; /* Cor do cursor vermelha */
}
</style> 